import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ContactosPermisosContainer from './PageContainer';

function ContactosYPermisos() {
  return (
    <>
      <Switch>
        <Route path='/contactos-permisos'>
          <ContactosPermisosContainer />
        </Route>
      </Switch>
    </>
  );
}

export { ContactosYPermisos };
